import React, { useEffect, useState } from "react";
import {
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Divider as MuiDivider,
  Tooltip,
  tooltipClasses,
  DialogTitle,
  DialogActions,
  DialogContentText,
  Button,
  Paper,
  Box,
} from "@mui/material";
import Deletes from "./Deletes.css";
import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

const Delete = ({
  title,
  description,
  onConfirm,
  onCancel,
  loading,
  onConfirmBulk,
  getCount,
  deleteTasksIds,
}) => {
  const [open, setOpen] = useState(false);
  const [deletePost, setDeletePost] = useState(null);
  const { t } = useTranslation();

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div>
        <Box className="box_delete">
          <DialogContentText
            id="responsive-dialog-title"
            sx={{ borderRadius: "8px" }}
            className="delete_dialog_content1"
          >
            {title}
          </DialogContentText>
          <DialogContentText
            id="responsive-dialog-title"
            className="delete_dialog_content2"
          >
            {description}
          </DialogContentText>
          <DialogActions>
            <Button autoFocus onClick={onCancel} className="delete_button">
              {t("Cancel")}
            </Button>

            <Button
              onClick={() => onConfirmBulk(deleteTasksIds)}
              className="delete_button"
              autoFocus
              sx={{ width: "170px" }}
            >
              {loading ? (
                <CircularProgress
                  color="secondary"
                  style={{ width: "20px", height: "20px" }}
                />
              ) : (
                t("selected_task_delete_button")
              )}
              {/*   {t("Confirm")} */}
            </Button>

            <Button onClick={onConfirm} className="delete_button" autoFocus>
              {t("Delete_all") +
                `${getCount ? getCount?.count : "0"}` +
                t("tasks")}
            </Button>
          </DialogActions>
        </Box>

        {/* </DialogActions> */}
      </div>
    </>
  );
};

export default Delete;
